import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('span', { 'className': `chevron-left-icon ${ !!this.props.className ? this.props.className : '' }` }, React.createElement('svg', {
        'width': '16',
        'height': '16',
        'viewBox': '0 0 6.3439523 6.3500001',
        'version': '1.1'
    }, React.createElement('g', { 'transform': 'translate(-271.86901,-340.92364)' }, React.createElement('path', { 'd': 'm 276.32944,347.00906 0.3942,-0.3942 -2.56188,-2.51637 2.56175,-2.51621 -0.39405,-0.39405 -2.97112,2.91042 z' }))));
}